const capsule = 'capsule';
const chewable = 'chewable';

function calculate_age(dob) {
    var now = new Date();
    var age = now.getFullYear() - dob.getFullYear();
    var m = now.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) {
        age--;
    }
    return age;
}

// DOB field formatting and validation
function formatDOBInput(input) {
    let value = input.value.replace(/\D/g, ''); // Remove all non-digits

    if (value.length >= 2) {
        value = value.substring(0, 2) + '/' + value.substring(2);
    }
    if (value.length >= 5) {
        value = value.substring(0, 5) + '/' + value.substring(5, 9);
    }

    input.value = value;
}

function validateDOBFormat(dobValue) {
    // Check if format matches MM/DD/YYYY
    const dobRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;

    if (!dobRegex.test(dobValue)) {
        return false;
    }

    // Parse the date parts
    const parts = dobValue.split('/');
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    // Create date object and validate
    const date = new Date(year, month - 1, day);

    // Check if the date is valid and matches input
    if (date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day) {
        return false;
    }

    // Check if date is not in the future
    const currentDate = new Date();
    if (date > currentDate) {
        return false;
    }

    return true;
}

const HSF_FORM_COOKIE_NAME = 'hsf-form-obj';

function parseHSFFormCookieValue(raw) {
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch (_encodedError) {
    try {
      return JSON.parse(raw);
    } catch (_legacyError) {
      return null;
    }
  }
}

function getHSFFormCookie() {
  return parseHSFFormCookieValue(getCookie(HSF_FORM_COOKIE_NAME));
}

function setHSFFormCookie(formObj) {
  setCookie(HSF_FORM_COOKIE_NAME, encodeURIComponent(JSON.stringify(formObj)), 30);
}

document.addEventListener("DOMContentLoaded", function () {
    const formObj = getHSFFormCookie();
    if (formObj) {
      const { first_name, last_name, day, month, year, dob } = formObj;
      if (first_name) document.getElementById('first_name').value = first_name;
      if (last_name) document.getElementById('last_name').value = last_name;
      if (dob && document.getElementById('dob')) {
        document.getElementById('dob').value = dob;
      } else {
        if (day) document.getElementById('day').value = day;
        if (month) document.getElementById('month').value = month;
        if (year) document.getElementById('year').value = year;
    }
  }
});

function formValidationError(first_name, last_name, month, year, day, dob) {
  let formError = false;
  if (first_name.value == '') {
    document.querySelector(
      "form .error-msg.first-name"
    ).innerHTML = KROWN.settings.hsf.hsf_form_field_error;
    first_name.classList.add('error');
    formError = true;
  }
  if (last_name.value == '') {
    document.querySelector(
      "form .error-msg.last-name"
    ).innerHTML = KROWN.settings.hsf.hsf_form_field_error;
    last_name.classList.add('error');
    formError = true;
  }

  // Check if DOB field exists and validate it (format only, age validation happens in terms check)
  if (dob && dob.value.trim() !== '') {
    if (!validateDOBFormat(dob.value.trim())) {
      document.querySelector(
        "form .error-msg.dob-error"
      ).innerHTML = '<span>Please enter a valid date in MM/DD/YYYY format</span>';
      dob.classList.add('error');
      formError = true;
    }
  } else if (dob && dob.value.trim() === '') {
    // DOB field is empty
    document.querySelector(
      "form .error-msg.dob-error"
    ).innerHTML = KROWN.settings.hsf.hsf_form_field_error;
    dob.classList.add('error');
    formError = true;
  }

  // Original birth date validation for separate fields (if they exist and DOB field is not used)
  if ((!dob || dob.value.trim() === '') && (month.value == '' || year.value == '' || day.value == '')) {
    document.querySelector(
      "form .error-msg.birth-date"
    ).innerHTML = KROWN.settings.hsf.hsf_form_field_error;
    if (month.value == '') month.classList.add('error');
    if (year.value == '') year.classList.add('error');
    if (day.value == '') day.classList.add('error');
    formError = true;
  }
  if (formError) {
    return true;
  }
  return false;
}

function clearErrorMsg() {
  document.querySelectorAll('#HSFChildForm .form-input-field').forEach(function(elm) {
    elm.classList.remove('error');
  })
  document.querySelectorAll("form .error-msg").forEach(elm=>{
    elm.innerHTML = '';
  });
}

const inputFields = document.querySelectorAll('#HSFChildForm .form-input-field');
inputFields.forEach(function(elm) {
  elm.addEventListener('change', function() {
    let termsCheck = document.getElementById("terms_check").checked;
    if (termsCheck) {
      document.getElementById("terms_check").checked = false;
      clearErrorMsg();
      document.getElementById("parentSectionProducts").classList.add("blurry");
      document.getElementById("childSectionHeading").classList.add("blurry");
      document.getElementById("childSectionProducts").classList.add("blurry");
      document.getElementById("childSectionHeading").classList.remove("grid");
      // document.getElementById("childSectionProducts").classList.remove("grid");
      if (!document.querySelector(".bundler-child-form").classList.contains("bundler-form--empty")) {
        document.querySelector(".bundler-child-form").classList.add("bundler-form--empty");
      }
      if (document.getElementById("hsf-component").classList.contains("bundler-full")) {
        document.getElementById("hsf-component").classList.remove("bundler-full");
        $('#bundle_submit_button').addClass('disabled');
      }
    }
  });
});

function hasValidHSFChildAndAdultProduct() {
  let adultItemCount = 0;
  let childItemCount = 0;
  let hasEmptySlot = false;
  document.querySelectorAll(".bundler__content-products .bundler-product").forEach((elm) => {
    if (elm.dataset.adultProduct) {
      adultItemCount++;
    } else if(elm.dataset.childProduct) {
      childItemCount++;
    }
    if (elm.classList.contains("bundler-product--empty")) {
      hasEmptySlot = true;
    }
  });
  if (adultItemCount > 0 && childItemCount > 0 && !hasEmptySlot ) {
    return true;
  }
  return false;
}

// Function to check if basic validation would fail (without showing errors)
function wouldValidationFail() {
  var elements = document.getElementById("HSFChildForm")?.elements;
  if (!elements) {
    return false;
  }
  
  const { first_name, last_name, month, year, day, dob } = elements;
  
  // Check if any required fields are empty (without showing errors)
  if (first_name.value == '' || last_name.value == '') {
    return true;
  }
  
  // Check DOB field
  if (dob && dob.value.trim() !== '') {
    if (!validateDOBFormat(dob.value.trim())) {
      return true;
    }
  } else if (dob && dob.value.trim() === '') {
    return true;
  }
  
  // Check separate date fields
  if ((!dob || dob.value.trim() === '') && (month.value == '' || year.value == '' || day.value == '')) {
    return true;
  }
  
  return false;
}

// Function to handle checkbox validation (reusable for both click and change events)
function handleTermsCheckboxValidation(checkbox) {
  // Get the checkbox element to ensure we have the latest state
  const checkboxElement = document.getElementById("terms_check");
  if (!checkboxElement) {
    return;
  }
  
  // Use the actual element's checked state, not the parameter (which might be stale)
  if (checkboxElement.checked) {
    // Only clear errors when checking the checkbox (not when unchecking)
    clearErrorMsg();
    var elements = document.getElementById("HSFChildForm").elements;
    if (!elements) {
      return;
    }
    const { first_name, last_name, month, year, day, dob } = elements;
    if (formValidationError(first_name, last_name, month, year, day, dob)) {
      // Make checkbox unchecked if validation error
      // Use setTimeout to ensure errors are displayed first
      setTimeout(() => {
        const termsCheck = document.getElementById("terms_check");
        if (termsCheck) {
          termsCheck.checked = false;
        }
      }, 0);
      return true;
    }
    let birthDate;
    let formObj = {
      first_name: first_name.value,
      last_name: last_name.value,
    };

    // Check if DOB field is used and has value
    if (dob && dob.value.trim() !== '') {
      const parts = dob.value.trim().split('/');
      const dobMonth = parseInt(parts[0], 10);
      const dobDay = parseInt(parts[1], 10);
      const dobYear = parseInt(parts[2], 10);

      birthDate = new Date(dobYear, dobMonth - 1, dobDay);
      formObj.dob = dob.value.trim();
      formObj.year = dobYear.toString();
      formObj.day = dobDay.toString();
      formObj.month = dobMonth.toString();
    } else {
      // Use separate month/day/year fields
      formObj.year = year.value;
      formObj.day = day.value;
      formObj.month = month.value;
      const dateStr = formObj.year + "/" + formObj.month + "/" + formObj.day;
      birthDate = new Date(dateStr);
    }
    const currentDate = new Date();
    
    const age = calculate_age(birthDate);
    let min_age = 4;
    let max_age = 12;
    
    const child_products = document.querySelectorAll("#childSectionProducts .product-item");
    child_products.forEach(elm => {
      let min_capsule_age = elm.getAttribute('data-hsf_min_age_for_capsules');
      let max_capsule_age = elm.getAttribute('data-hsf_max_age_for_capsules');
  
      if(max_capsule_age && min_capsule_age) {
          min_capsule_age = parseInt(min_capsule_age)
          max_capsule_age = parseInt(max_capsule_age)
        if(age>=min_capsule_age && age<=max_capsule_age){
          elm.classList.remove('hidden');
        } else {
          elm.classList.add('hidden');
        }
      } 

      if(max_capsule_age && (max_age==0 || max_capsule_age>max_age) ) {
        max_age = max_capsule_age
      }

      if(min_capsule_age && (min_age==0 || min_capsule_age<min_age) ) {
        min_age = min_capsule_age
      }
    });

    if (isNaN(birthDate) || birthDate > currentDate) {
      let error_text = KROWN.settings.hsf.hsf_form_age_input_error;
      error_text = error_text.replace('{{ min_age }}', min_age)?.replace('{{ max_age }}', max_age)

      if (dob && dob.value.trim() !== '') {
        // Show error in DOB field
        document.querySelector("form .error-msg.dob-error").innerHTML = `<span>${error_text}</span>`;
        dob.classList.add('error');
      } 
      else {
        // Show error in separate fields
        document.querySelector("form .error-msg.birth-date").innerHTML = `<span>${error_text}</span>`;
        month.classList.add('error');
        year.classList.add('error');
        day.classList.add('error');
      }
      document.getElementById("terms_check").checked = false;
      return true;
    }
    
    if(age>=min_age && age <= max_age) {
      // document.getElementById("childSectionHeading").classList.remove("hidden");
      // document.getElementById("childSectionProducts").classList.remove("hidden");
      document.getElementById("childSectionHeading").classList.add("grid");
      document.getElementById("childSectionProducts").classList.add("grid");
      document.querySelector(".bundler-child-form").classList.remove("bundler-form--empty");
      setHSFFormCookie(formObj);
      if (hasValidHSFChildAndAdultProduct()) {
        document.getElementById("hsf-component").classList.add("bundler-full");
        $('#bundle_submit_button').removeClass('disabled');
      }
      //If everything is valid remove class blurry from adult child products container
      document.getElementById("parentSectionProducts").classList.remove("blurry");
      
      // Check if adult product is already added - if yes, enable child section
      const bundler = document.querySelector('hsf-product-bundler');
      if (bundler) {
        // Check all bundler product slots for adult products
        const bundlerProductSlots = bundler.querySelectorAll('[data-js-bundler-product]');
        const hasAdultProduct = Array.from(bundlerProductSlots).some(slot => {
          // Check if slot has adult product data attribute and is not empty
          return slot.dataset.adultProduct === 'true' && 
                 slot.dataset.id && 
                 slot.dataset.id !== '' && 
                 !slot.classList.contains('bundler-product--empty');
        });
        
        console.log('🔍 Checkbox checked - Adult product check:', {
          hasAdultProduct: hasAdultProduct,
          totalSlots: bundlerProductSlots.length,
          adultSlots: Array.from(bundlerProductSlots).filter(s => s.dataset.adultProduct === 'true').length
        });
        
        if (hasAdultProduct) {
          // Adult product already exists, enable child section
          console.log('✅ Adult product found - Enabling child section');
          document.getElementById("childSectionProducts").classList.remove("blurry");
          document.getElementById("childSectionHeading").classList.remove("blurry");
        } else {
          console.log('⏳ No adult product found - Child section remains disabled');
        }
      }
      
      return false;
    } else {
      let error_text = KROWN.settings.hsf.hsf_form_age_input_error;
      error_text = error_text.replace('{{ min_age }}', min_age)?.replace('{{ max_age }}', max_age)

      if (dob && dob.value.trim() !== '') {
        // Show error in DOB field
        document.querySelector("form .error-msg.dob-error").innerHTML = `<span>${error_text}</span>`;
        dob.classList.add('error');
      } else {
        // Show error in separate fields
        document.querySelector("form .error-msg.birth-date").innerHTML = `<span>${error_text}</span>`;
        month.classList.add('error');
        year.classList.add('error');
        day.classList.add('error');
      }
      document.getElementById("terms_check").checked = false;
      return true;
    }
  } else {
    document.getElementById("parentSectionProducts").classList.add("blurry");
    document.getElementById("childSectionHeading").classList.add("blurry");
    document.getElementById("childSectionProducts").classList.add("blurry");
    if (!document.querySelector(".bundler-child-form").classList.contains("bundler-form--empty")) {
      document.querySelector(".bundler-child-form").classList.add("bundler-form--empty");
    }
    if (document.getElementById("hsf-component").classList.contains("bundler-full")) {
      document.getElementById("hsf-component").classList.remove("bundler-full");
      $('#bundle_submit_button').addClass('disabled');
    }
  }
}

// Add event listeners for both click and change events
function initializeTermsCheckboxListeners() {
  const termsCheckboxElement = document.getElementById("terms_check");
  if (termsCheckboxElement && !termsCheckboxElement.dataset.listenersAdded) {
    termsCheckboxElement.dataset.listenersAdded = 'true';
    
    let isProcessing = false;
    let validationBlocked = false;
    
    // Mousedown handler - prevent checkbox toggle at the earliest stage if validation fails
    termsCheckboxElement.addEventListener("mousedown", function (event) {
      // If checkbox is currently unchecked and we're trying to check it
      if (!this.checked) {
        // Check validation BEFORE allowing the checkbox to toggle
        if (wouldValidationFail()) {
          // Prevent the default mousedown behavior
          event.preventDefault();
          event.stopImmediatePropagation();
          
          // Set flag to block the change event
          validationBlocked = true;
          
          // Clear previous errors and show new validation errors
          clearErrorMsg();
          var elements = document.getElementById("HSFChildForm")?.elements;
          if (elements) {
            const { first_name, last_name, month, year, day, dob } = elements;
            formValidationError(first_name, last_name, month, year, day, dob);
          }
          
          // Reset flag after a short delay
          setTimeout(() => {
            validationBlocked = false;
          }, 100);
          
          return false;
        }
      }
    }, true); // Use capture phase
    
    // Click handler - additional safety check
    termsCheckboxElement.addEventListener("click", function (event) {
      if (validationBlocked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.checked = false;
        return false;
      }
    }, true); // Use capture phase
    
    // Change handler - validate when checkbox state changes (works for both click and Enter key)
    termsCheckboxElement.addEventListener("change", function (event) {
      // If validation was blocked, prevent the change
      if (validationBlocked) {
        event.preventDefault();
        event.stopPropagation();
        this.checked = false;
        return false;
      }
      
      // Prevent double validation
      if (isProcessing) {
        return;
      }
      
      isProcessing = true;
      
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => {
        handleTermsCheckboxValidation(this);
        isProcessing = false;
      }, 0);
    });
  }
}

// Initialize on DOMContentLoaded or immediately if already loaded
if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initializeTermsCheckboxListeners);
} else {
  // DOM already loaded, initialize immediately
  initializeTermsCheckboxListeners();
}

// DOB field event listeners
document.addEventListener('DOMContentLoaded', function() {
  const dobInput = document.getElementById('dob');

  if (dobInput) {
    // Format input as user types
    dobInput.addEventListener('input', function(e) {
      formatDOBInput(e.target);

      // Clear any existing error when user starts typing
      const errorElement = document.querySelector('.error-msg.dob-error');
      if (errorElement) {
        errorElement.innerHTML = '';
      }
      e.target.classList.remove('error');
    });

    // Validate on blur
    dobInput.addEventListener('blur', function(e) {
      const dobValue = e.target.value.trim();
      const errorElement = document.querySelector('.error-msg.dob-error');

      if (dobValue === '') {
        return; // Don't validate empty field on blur
      }

      if (!validateDOBFormat(dobValue)) {
        if (errorElement) {
          errorElement.innerHTML = '<span>Please enter a valid date in MM/DD/YYYY format</span>';
        }
        e.target.classList.add('error');
        return;
      }



      // Clear error if validation passes
      if (errorElement) {
        errorElement.innerHTML = '';
      }
      e.target.classList.remove('error');
    });

    // Handle keydown for better backspace behavior
    dobInput.addEventListener('keydown', function(e) {
      const currentValue = e.target.value;
      const cursorPosition = e.target.selectionStart;

      // Handle backspace specially
      if (e.key === 'Backspace') {
        // If cursor is right after a slash, move cursor back one more position
        if (cursorPosition > 0 && currentValue[cursorPosition - 1] === '/') {
          e.preventDefault();
          const newValue = currentValue.slice(0, cursorPosition - 2) + currentValue.slice(cursorPosition);
          e.target.value = newValue;
          e.target.setSelectionRange(cursorPosition - 2, cursorPosition - 2);

          // Clear any existing error when user starts editing
          const errorElement = document.querySelector('.error-msg.dob-error');
          if (errorElement) {
            errorElement.innerHTML = '';
          }
          e.target.classList.remove('error');
        }
        return;
      }

      // Allow delete, tab, escape, enter, arrow keys
      if (['Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key) ||
          // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
          (e.ctrlKey && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase()))) {
        return;
      }

      // Only allow numbers
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }

      // Prevent input if already at max length
      if (currentValue.length >= 10) {
        e.preventDefault();
      }
    });
  }
});